<template>
  <div class="koc-tooltip-container">
    <div 
      class="koc-tooltip"
      :class="getClassName"
    >
      {{ text }}
    </div>
    <div
      @mouseover="showTooltip = true"
      @mouseleave="showTooltip = false"
    >
      <slot />
    </div>
  </div>
</template>
<script src="./tooltip.js"></script>
<style lang="scss" scoped src="./tooltip.scss"></style>